import React from "react";
import { Box, Button, Typography } from "@mui/material";

import heroBackground from "../../../static/images/distant_amplifier_bundle/hero-background.webp";
import { DISTANT_HERO } from "../../ProductHeroes";
import bassSuiteHero from "../../../static/images/distant_bass_suite/plugin-hero.webp";

const DistantBundleFrontpageTile = () => (
  <Box sx={{
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    overflow: "hidden",
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), #000 95%), url(${heroBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}>
    <Box sx={{ p: { xs: 3, md: 4 }, width: "100%", maxWidth: "640px" }}>
      <Box sx={{ position: "relative", width: "100%", aspectRatio: "3 / 2", mb: 3, isolation: "isolate" }}>
        <Box
          component="img"
          src={bassSuiteHero}
          alt="BassSuite - Distant plugin interface"
          width={1600}
          height={1079}
          loading="eager"
          decoding="async"
          sx={{
            position: "absolute",
            top: "3%",
            right: 0,
            width: "68%",
            height: "auto",
            zIndex: 1,
            transform: "perspective(1200px) rotateY(-8deg) rotateZ(5deg)",
            filter: "drop-shadow(0 16px 20px rgba(0,0,0,0.65))",
          }}
        />
        <Box
          component="img"
          src={DISTANT_HERO.src}
          alt="ToneSuite - Distant plugin interface in front of BassSuite"
          width={DISTANT_HERO.width}
          height={DISTANT_HERO.height}
          loading="eager"
          decoding="async"
          sx={{
            position: "absolute",
            bottom: "2%",
            left: 0,
            width: "78%",
            height: "auto",
            zIndex: 2,
            transform: "perspective(1200px) rotateY(8deg) rotateZ(-4deg)",
            filter: "drop-shadow(0 22px 24px rgba(0,0,0,0.8))",
          }}
        />
      </Box>
      <Typography variant="h3" sx={{ fontSize: 30 }}>
        Distant Tone Bundle
      </Typography>
      <Typography sx={{ fontSize: { xs: "15px", md: "20px" } }}>
        <i>Two suites. One massive sound.</i>
      </Typography>
      <Button
        component="a"
        href="/product/distant-tone-bundle"
        aria-label="Learn more about Distant Tone Bundle"
        sx={{
          mt: 4,
          background: "white",
          color: "black",
          width: { xs: "75%", md: "150px" },
          textDecoration: "none",
        }}
        variant="outlined"
      >
        Learn More<span className="sr-only"> about Distant Tone Bundle</span>
      </Button>
    </Box>
  </Box>
);

export default DistantBundleFrontpageTile;
